<div class="row" [formGroup]="form">
  <div class="col-md-3">
    <mat-form-field2>
      <input
        matInput
        placeholder="Days"
        i18n-placeholder
        formControlName="days"
        type="number"
        pattern="^-?(0|[1-9]\d*)?$"
      />
      <mat-error *ngIf="form.get('days').touched && form.get('days').hasError('required')">
        <ng-container i18n>Days are required</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('days').touched && form.get('days').hasError('min')">
        <ng-container i18n>Days need to be at least 0</ng-container>
      </mat-error>
      <mat-error i18n *ngIf="form.get('days').hasError('pattern')"> Only whole numbers allowed </mat-error>
    </mat-form-field2>
  </div>
  <div class="col-md-3">
    <mat-form-field2>
      <input
        matInput
        placeholder="Hours"
        i18n-placeholder
        formControlName="hours"
        type="number"
        pattern="^-?(0|[1-9]\d*)?$"
      />
      <mat-error *ngIf="form.get('hours').hasError('required')">
        <ng-container i18n>Hours are required</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('hours').hasError('min')">
        <ng-container i18n>Hours need to be at least 0</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('hours').hasError('max')">
        <ng-container i18n>Hours need to be at most 24</ng-container>
      </mat-error>
      <mat-error i18n *ngIf="form.get('hours').hasError('pattern')"> Only whole numbers allowed </mat-error>
    </mat-form-field2>
  </div>
  <div class="col-md-6">
    <mat-form-field2 class="mat-block">
      <mat-select placeholder="Time event type" i18n-placeholder formControlName="event">
        <mat-option *ngFor="let event of timeEvents" [value]="event.event">
          {{ event.title }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('event').touched && form.get('event').hasError('required')">
        <ng-container i18n>Time event type is required</ng-container>
      </mat-error>
    </mat-form-field2>
  </div>
</div>
